import { Component, EventEmitter, Output, ViewEncapsulation, ChangeDetectionStrategy, Input, ChangeDetectorRef, ContentChildren, QueryList, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { PhxModalBaseComponent } from './phx-modal-base.component';
import { PhxModalBackground } from './phx-modal.types';
import { PhxBreakpointObserverService } from '../../services/phx-breakpoint-service';
import { PHX_BACKGROUND } from '../../constants';
import { Cross } from '../icon/icon-map';

@Component({
  selector: 'phx-modal',
  templateUrl: './phx-modal.component.html',
  styleUrls: ['./phx-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhxModalComponent extends PhxModalBaseComponent {
  @Input() phxFullScreen: boolean = false;
  @Input() phxBackground: PhxModalBackground = PHX_BACKGROUND.STANDARD;
  @Input() phxHideCloseIcon: boolean = false;
  @Input() phxOffset: string = '';

  @Output() phxCloseIconClicked = new EventEmitter<void>();

  public readonly PHX_BACKGROUND = PHX_BACKGROUND;
  public readonly CloseIcon: string = Cross;
  public breakpointObserverSubscription: Subscription;
  public isMobileView: boolean = false;
  public showCrossOnMobile: boolean = false;

  constructor(private _phxBreakPointObserver: PhxBreakpointObserverService, private _cdr: ChangeDetectorRef) {
    super();
  }

  public ngOnInit(): void {
    this.breakpointObserverSubscription = this._phxBreakPointObserver.smMobile.subscribe((isMobile) => {
      this.isMobileView = isMobile;
      this._cdr.markForCheck();
    });
  }

  public ngOnDestroy(): void {
    this.breakpointObserverSubscription?.unsubscribe();
  }

  closeIconClicked() {
    this.phxCloseIconClicked.emit();
    if (this.phxAutoClose) {
      this.closeModal();
    }
  }
}
